import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import { html } from 'lit';

export const Marker = webcomponent(
  'x-marker',
  ({
    icon,
    label,
    labelBottom,
    textColor = '#333',
    backgroundColor = '#fff',
    borderColor = '#1e90ff',
  }: {
    icon?: string;
    label?: string;
    labelBottom?: string;
    textColor?: string;
    backgroundColor?: string;
    borderColor?: string;
  }) => {
    const content = icon
      ? html`<span class=${icon}></span>`
      : labelBottom
        ? html`
            <div class="flex flex-col items-center justify-center leading-none">
              <span class="text-sm">${label || '1'}</span>
              <span class="text-sm">${labelBottom}</span>
            </div>
          `
        : html`<span>${label || '1'}</span>`;

    return html`
      <div
        class="font-sans font-semibold flex items-center justify-center w-9 h-9 rounded-full shadow select-none"
        style="background-color: ${backgroundColor}; border: 3px solid ${borderColor}; color: ${textColor};"
      >
        ${content}
      </div>
    `;
  },
  {
    properties: {
      icon: { type: String },
      label: { type: String },
      labelBottom: { type: String },
      textColor: { type: String },
      backgroundColor: { type: String },
      borderColor: { type: String },
    },
  },
);
